(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  document.addEventListener('vitelyn:cart:updated', (event) => {
    const count = Number(event.detail && event.detail.itemCount) || 0;
    document.querySelectorAll('[data-cart-link]').forEach((link) => {
      link.setAttribute('aria-label', count > 0 ? `${link.dataset.labelCart}, ${count} ${link.dataset.labelItems}` : link.dataset.labelCart);
      const badge = link.querySelector('[data-cart-badge]');
      if (badge) { badge.textContent = String(count); badge.hidden = count === 0; }
    });
  });

  (function () {
    const header = document.querySelector('[data-header]');
    if (header) {
      const onScroll = () => header.classList.toggle('is-lifted', window.scrollY > 8);
      onScroll();
      window.addEventListener('scroll', onScroll, { passive: true });
    }
    document.querySelectorAll('[data-mobile-menu]').forEach((menu) => {
      const summary = menu.querySelector('summary');
      const root = document.documentElement;
      const close = (refocus) => {
        if (!menu.open) return;
        menu.open = false;
        if (refocus) summary.focus();
      };
      menu.addEventListener('toggle', () => { root.classList.toggle('is-locked', menu.open); });
      menu.querySelectorAll('a[href]').forEach((a) => a.addEventListener('click', () => close(false)));
      document.addEventListener('keydown', (e) => { if (e.key === 'Escape') close(true); });
      window.matchMedia('(min-width: 1024px)').addEventListener('change', (e) => { if (e.matches) close(false); });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lx-faq"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      root.querySelectorAll('[aria-controls^="faq-p-"]').forEach(function (btn) {
        if (btn.dataset.bound) return;
        btn.dataset.bound = '1';
        var panel = document.getElementById(btn.getAttribute('aria-controls'));
        function set(open) {
          btn.setAttribute('aria-expanded', open ? 'true' : 'false');
          panel.toggleAttribute('data-open', open);
          panel.inert = !open;
        }
        set(false);
        btn.addEventListener('click', function () { set(btn.getAttribute('aria-expanded') !== 'true'); });
      });
    }
    function boot(scope) { (scope || document).querySelectorAll('[data-faq]').forEach(init); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); }); else boot();
    document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
  })();

  } catch(e) { console.error(e); }
})();
})();
